import { render, staticRenderFns } from "./industries.vue?vue&type=template&id=44a587f2"
import script from "./industries.vue?vue&type=script&lang=js"
export * from "./industries.vue?vue&type=script&lang=js"
import style0 from "./industries.vue?vue&type=style&index=0&id=44a587f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports